import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import messages from './AccessDenied.messages';

function AccessDeniedLandingPage({ history }) {
    const translator = useContext(TranslatorContext);
    useEffect(() => {
        history.push('/access-denied');
    // Mount once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Loader loaded={false} text={translator(messages.requestProcessing)} />;
}

AccessDeniedLandingPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};

export default withRouter(AccessDeniedLandingPage);
